import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function SignUpScreen() {
    const [isVisible, setIsVisible] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Component mount olduğunda animasyonu başlat
        setIsVisible(true);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Input değiştiğinde hata mesajını temizle
        if (error) setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        setSuccess("");

        // Email format kontrolü
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError("Geçerli bir email adresi giriniz.");
            setIsLoading(false);
            return;
        }

        // Şifre kontrolü
        if (formData.password !== formData.confirmPassword) {
            setError("Şifreler eşleşmiyor. Lütfen tekrar kontrol edin.");
            setIsLoading(false);
            return;
        }

        // Şifre uzunluk kontrolü
        if (formData.password.length < 6) {
            setError("Şifre en az 6 karakter olmalıdır.");
            setIsLoading(false);
            return;
        }

        // Ad kontrolü (boş olmamalı)
        if (!formData.name.trim()) {
            setError("Ad alanı boş olamaz.");
            setIsLoading(false);
            return;
        }

        // Soyad kontrolü (boş olmamalı)
        if (!formData.surname.trim()) {
            setError("Soyad alanı boş olamaz.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch("/rest/user/addUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: formData.name,
                    surname: formData.surname,
                    email: formData.email,
                    password: formData.password,
                    userType: isAdmin ? 2 : 1,
                }),
            });

            console.log("Response status:", response.status);
            const responseData = await response.json();
            console.log("Response data:", responseData);

            // Başarılı kayıt kontrolü - message varsa ve "successful" içeriyorsa başarılı
            if (
                responseData.message &&
                responseData.message.includes("successful")
            ) {
                console.log("Üye olma başarılı:", responseData);

                // Üye olma başarılı olduğunda otomatik giriş yap
                try {
                    const loginResponse = await fetch("/rest/User/Login", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            email: formData.email,
                            password: formData.password,
                        }),
                    });

                    const loginData = await loginResponse.json();
                    console.log("Otomatik giriş response:", loginData);

                    if (loginData.value && loginData.value.token) {
                        // Token'ı localStorage'a kaydet
                        localStorage.setItem(
                            "authToken",
                            loginData.value.token
                        );

                        // Kullanıcı bilgilerini kaydet
                        const userInfo = {
                            id: loginData.value.id,
                            name: loginData.value.name,
                            surname: loginData.value.surname,
                            email: loginData.value.email,
                            username: loginData.value.username,
                            phoneNumber: loginData.value.phoneNumber,
                            userType: loginData.value.userType,
                            userGender: loginData.value.userGender,
                            isVerified: loginData.value.isVerified,
                        };
                        localStorage.setItem("user", JSON.stringify(userInfo));

                        // Navbar'ın güncellenmesi için custom event dispatch et
                        window.dispatchEvent(new Event("loginStatusChanged"));

                        // Admin kontrolü ve yönlendirme mesajı
                        const isAdminUser = loginData.value.userType === 2;
                        if (isAdminUser) {
                            setSuccess(
                                `Hoş geldiniz ${loginData.value.name}! Admin hesabınız başarıyla oluşturuldu ve giriş yapıldı. Yönetim paneline yönlendiriliyorsunuz...`
                            );
                        } else {
                            setSuccess(
                                `Hoş geldiniz ${loginData.value.name}! Hesabınız başarıyla oluşturuldu ve giriş yapıldı. Cyprus Yacht Club'a katıldığınız için teşekkürler! Ana sayfaya yönlendiriliyorsunuz...`
                            );
                        }

                        // 3 saniye sonra uygun sayfaya yönlendir
                        setTimeout(() => {
                            if (isAdminUser) {
                                navigate("/admin");
                            } else {
                                navigate("/");
                            }
                        }, 3000);
                    } else {
                        // Otomatik giriş başarısız olursa - admin kontrolü için isAdmin state'ini kullan
                        if (isAdmin) {
                            setSuccess(
                                `Hoş geldiniz ${formData.name}! Admin hesabınız başarıyla oluşturuldu. Lütfen giriş yapın. Yönetim paneline yönlendiriliyorsunuz...`
                            );
                            setTimeout(() => {
                                navigate("/admin");
                            }, 3000);
                        } else {
                            setSuccess(
                                `Hoş geldiniz ${formData.name}! Hesabınız başarıyla oluşturuldu. Cyprus Yacht Club'a katıldığınız için teşekkürler! Lütfen giriş yapın. Ana sayfaya yönlendiriliyorsunuz...`
                            );
                            setTimeout(() => {
                                navigate("/");
                            }, 3000);
                        }
                    }
                } catch (loginError) {
                    console.error("Otomatik giriş hatası:", loginError);
                    // Otomatik giriş hatası durumunda da admin kontrolü yap
                    if (isAdmin) {
                        setSuccess(
                            `Hoş geldiniz ${formData.name}! Admin hesabınız başarıyla oluşturuldu. Lütfen giriş yapın. Yönetim paneline yönlendiriliyorsunuz...`
                        );
                        setTimeout(() => {
                            navigate("/admin");
                        }, 3000);
                    } else {
                        setSuccess(
                            `Hoş geldiniz ${formData.name}! Hesabınız başarıyla oluşturuldu. Cyprus Yacht Club'a katıldığınız için teşekkürler! Lütfen giriş yapın. Ana sayfaya yönlendiriliyorsunuz...`
                        );
                        setTimeout(() => {
                            navigate("/");
                        }, 3000);
                    }
                }
            } else {
                // Hata durumu
                throw new Error(
                    responseData.message || "Üye olma işlemi başarısız oldu"
                );
            }
        } catch (error) {
            console.error("Üye olma hatası:", error);
            setError(
                error.message || "Üye olma işlemi sırasında bir hata oluştu"
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
            <div
                className="absolute inset-0 opacity-20 bg-cover bg-center"
                style={{ backgroundImage: `url(/images/hero-1.jpg)` }}
            ></div>
            <div
                className={`relative w-full max-w-md p-8 bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10 transition-all duration-700 transform ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-12"
                }`}
            >
                {/* Üst Navigasyon Alanı */}
                <div className="absolute -top-12 left-0">
                    {/* Geri Dönüş Butonu */}
                    <Link
                        to="/"
                        className="text-white/60 hover:text-white flex items-center gap-2 transition-colors duration-300"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        <span>Ana Sayfa</span>
                    </Link>
                </div>

                <div
                    className={`mb-8 text-center transition-all delay-300 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <Link
                        to="/"
                        className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent inline-flex items-center gap-2"
                    >
                        Cyprus Yacht Club
                        <span className="text-2xl">⛵</span>
                    </Link>
                    <p className="mt-2 text-white/60">
                        Premium yat kiralama deneyimi
                    </p>
                </div>

                {/* Hata Mesajı */}
                {error && (
                    <div className="mb-4 p-3 bg-red-500/20 border border-red-500/30 rounded-xl text-red-400 text-sm">
                        {error}
                    </div>
                )}

                {/* Başarı Mesajı */}
                {success && (
                    <div className="mb-4 p-4 bg-green-500/20 border border-green-500/30 rounded-xl">
                        <div className="flex items-start gap-3">
                            <div className="flex-shrink-0">
                                {success.includes("Yönetim paneline") ? (
                                    // Admin ikonu
                                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                                        <svg
                                            className="w-4 h-4 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                ) : (
                                    // Normal kullanıcı ikonu
                                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                                        <svg
                                            className="w-4 h-4 text-white"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                    </div>
                                )}
                            </div>
                            <div className="flex-1">
                                <div className="text-green-400 text-sm font-medium mb-1 flex items-center gap-2">
                                    {success.includes("Yönetim paneline") ? (
                                        <>
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                                />
                                            </svg>
                                            Admin Hesabı Oluşturuldu!
                                        </>
                                    ) : (
                                        <>
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                            Hesabınız Oluşturuldu!
                                        </>
                                    )}
                                </div>
                                <div className="text-green-400/80 text-sm">
                                    {success}
                                </div>
                                {success.includes("yönlendiriliyorsunuz") && (
                                    <div className="mt-2 flex items-center gap-2 text-green-400/60 text-xs">
                                        <div className="animate-spin rounded-full h-3 w-3 border border-green-400/40 border-t-green-400"></div>
                                        <span>Yönlendiriliyor...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <form
                    onSubmit={handleSubmit}
                    className={`space-y-6 transition-all delay-500 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Ad
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                            placeholder="Adınız"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Soyad
                        </label>
                        <input
                            type="text"
                            name="surname"
                            value={formData.surname}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                            placeholder="Soyadınız"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            E-Mail
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                            placeholder="mail@example.com"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Şifre
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3 pr-12 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                placeholder="••••••••"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/80 transition-all duration-300 p-1 rounded-lg hover:bg-white/5"
                            >
                                {showPassword ? (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L12 12m-3.122-3.122l4.243 4.243M15 15l6 6m-6-6v.01M15 15l6-6m-6 6h.01"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Şifre Tekrar
                        </label>
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3 pr-12 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                placeholder="••••••••"
                                required
                            />
                            <button
                                type="button"
                                onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                }
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/80 transition-all duration-300 p-1 rounded-lg hover:bg-white/5"
                            >
                                {showConfirmPassword ? (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L12 12m-3.122-3.122l4.243 4.243M15 15l6 6m-6-6v.01M15 15l6-6m-6 6h.01"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    {/* Admin Checkbox */}
                    <div className="flex items-center p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 group w-full">
                        <div className="relative">
                            <input
                                type="checkbox"
                                id="adminCheckboxSignup"
                                checked={isAdmin}
                                onChange={(e) => setIsAdmin(e.target.checked)}
                                className="sr-only"
                            />
                            <label
                                htmlFor="adminCheckboxSignup"
                                className="flex items-center cursor-pointer"
                            >
                                <div
                                    className={`w-5 h-5 border-2 rounded-md transition-all duration-300 flex items-center justify-center ${
                                        isAdmin
                                            ? "bg-blue-500 border-blue-500 shadow-lg shadow-blue-500/30"
                                            : "bg-white/5 border-white/20 group-hover:border-white/40"
                                    }`}
                                >
                                    {isAdmin && (
                                        <svg
                                            className="w-3 h-3 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <span className="ml-3 text-white/80 font-medium group-hover:text-white transition-colors duration-300">
                                    Admin olarak kayıt ol
                                </span>
                            </label>
                        </div>
                        {isAdmin && (
                            <div className="ml-auto">
                                <div className="flex items-center gap-1 text-blue-400 text-xs font-medium">
                                    <svg
                                        className="w-4 h-4"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    <span>Yönetici</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center gap-2">
                                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                Üye olunuyor...
                            </div>
                        ) : (
                            "Üye Ol"
                        )}
                    </button>

                    <div className="text-center text-white/60">
                        Zaten hesabınız var mı?{" "}
                        <Link
                            to="/login"
                            className="text-blue-400 hover:text-blue-300 transition-colors"
                        >
                            Giriş Yap
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SignUpScreen;
